import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import TxnList from "./TxnList";
import useUniversalStore from "store/universalStore";
import ExpandableButton from "components/ExpandableButton";

function Home() {
  const { write, selectedMonth } = useUniversalStore((state) => state);
  const [animation, setAnimation] = useState("");
  const [hideCancelled, setHideCancelled] = useState(false);
  const isToday = dayjs(selectedMonth).isSame(dayjs(), "day");

  useEffect(() => {
    write({ selectedMonth: new Date() });
  }, []);

  const prevDate = async () => {
    const newDate = dayjs(selectedMonth).subtract(1, "days").toDate();
    write({ selectedMonth: newDate });
    setAnimation("animate__animated animate__slideInRight fast-animation");
  };

  const nextDate = async () => {
    if (isToday) return;
    const newDate = dayjs(selectedMonth).add(1, "days").toDate();
    write({ selectedMonth: newDate });
    setAnimation("animate__animated animate__slideInLeft fast-animation");
  };

  // const handleDate = (year,month,day)=>{
  //   let newDate = new Date(year,month);
  //   console.log("new Date ",newDate);
  //   setDate(newDate);
  // }

  const handleDate = (date) => {
    write({ selectedMonth: date });
  }

  return (
    <>
      <div className="row bg-app py-2">
        <div className="col-1">
          <i className="bi bi-arrow-left-circle-fill fs-2 btn btn-outline-light border-0"
            onClick={prevDate}
          />
        </div>
        <div className="col-10 my-2 d-flex gap-2 justify-content-center">
          <DatePicker
            selected={selectedMonth}
            onChange={(value) => write({ selectedMonth: value })}
            dateFormat="dd-MM-yyyy"
            maxDate={new Date()}
            className="datePicker"
            showIcon
            icon={<i className="bi bi-calendar-date text-white "></i>}
          />

          <i className={`fs-2 text-white cursor-pointer 
              ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`}
            onClick={() => setHideCancelled(!hideCancelled)}></i>

        </div>
        <div className="col-1" align="right">
          <i className={`bi bi-arrow-right-circle-fill fs-2 btn btn-outline-light border-0 ${isToday ? "disabled" : ""}`}
            onClick={nextDate}
          />
        </div>
      </div>

      <TxnList
        animation={animation}
        setAnimation={setAnimation}
        hideClosed={hideCancelled} />

      <div className="row position-absolute mb-5 mx-5 bottom-0 end-0">
        <ExpandableButton
          title="New Entry"
          formId="newTxn"
          // onClick={(e) => goToNextStep()}
          icon="bi bi-pencil-fill"
        />
      </div>
    </>
  );
}

export default Home;
